import React from "react";
import LegalLayout from "@/components/solanova/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-display text-xl md:text-2xl text-white font-light mt-10 mb-3">
    {children}
  </h2>
);

export default function AGB() {
  return (
    <LegalLayout
      title="Allgemeine Geschäfts­bedingungen"
      eyebrow="AGB"
      testId="agb-page"
    >
      <H2>1. Geltungsbereich</H2>
      <p>
        Diese Allgemeinen Geschäfts­bedingungen (nachfolgend „AGB“) gelten für alle Verträge,
        Angebote und Leistungen zwischen der Solanova GmbH, Vogelherd 5, 9225 Wilen-Gottshaus
        (nachfolgend „Solanova“) und ihren Kundinnen und Kunden („Auftraggeber“). Abweichende
        Bedingungen des Auftraggebers werden nur mit schriftlicher Bestätigung von Solanova Vertragsbestandteil.
      </p>

      <H2>2. Angebot und Vertragsabschluss</H2>
      <p>
        Unsere Angebote sind freibleibend. Ein Vertrag kommt erst mit schriftlicher Auftragsbestätigung
        oder mit dem Beginn der Ausführung durch Solanova zustande. Mündliche Nebenabreden bedürfen
        zu ihrer Wirksamkeit der schriftlichen Bestätigung.
      </p>

      <H2>3. Leistungsumfang</H2>
      <p>
        Solanova erbringt die im Vertrag bzw. in der Auftragsbestätigung beschriebenen Leistungen
        (Planung, Lieferung, Montage und Inbetriebnahme von Photovoltaik-Anlagen, Batterie­speichern
        und Wallboxen sowie damit verbundene Beratungs­leistungen). Änderungen am Leistungsumfang
        bedürfen einer schriftlichen Vereinbarung und können den Preis sowie die Liefertermine beeinflussen.
      </p>

      <H2>4. Preise und Zahlungsbedingungen</H2>
      <p>
        Alle Preise verstehen sich in Schweizer Franken (CHF) inklusive Mehrwertsteuer, sofern nicht
        anders vereinbart. Sofern nicht anders vereinbart, gelten folgende Zahlungsbedingungen:
      </p>
      <ul className="list-disc pl-6 space-y-1.5 text-white/65">
        <li>40% Anzahlung bei Auftragsbestätigung</li>
        <li>50% bei Lieferung des Materials</li>
        <li>10% nach erfolgreicher Inbetriebnahme</li>
      </ul>
      <p>Rechnungen sind innert 14 Tagen ab Rechnungsdatum ohne Abzug zahlbar.</p>

      <H2>5. Mitwirkungspflichten des Auftraggebers</H2>
      <p>
        Der Auftraggeber stellt rechtzeitig und unentgeltlich alle für die Auftrags­ausführung
        erforderlichen Voraussetzungen sicher (Zugang, Strom-/Wasseranschluss, behördliche
        Bewilligungen, Eigentümer­einverständnis). Verzögerungen, die hieraus entstehen, gehen
        nicht zulasten von Solanova.
      </p>

      <H2>6. Liefer- und Ausführungsfristen</H2>
      <p>
        Termine gelten als unverbindlich, sofern sie nicht ausdrücklich schriftlich als verbindlich
        bezeichnet wurden. Verzögerungen aufgrund höherer Gewalt, Lieferengpässe oder behördlicher
        Auflagen verlängern die Fristen entsprechend.
      </p>

      <H2>7. Gewährleistung und Garantien</H2>
      <p>
        Solanova leistet Gewähr im Rahmen der gesetzlichen Bestimmungen. Für gelieferte Komponenten
        gelten zusätzlich die Hersteller­garantien (Module bis 25 Jahre Leistungsgarantie,
        Wechselrichter und Speicher gemäss Hersteller). Bei Mängeln hat der Auftraggeber Solanova
        zunächst Gelegenheit zur Nachbesserung zu geben.
      </p>

      <H2>8. Haftung</H2>
      <p>
        Solanova haftet für Schäden nur bei Vorsatz oder grober Fahrlässigkeit. Die Haftung für
        leichte Fahrlässigkeit, indirekte Schäden, entgangenen Gewinn sowie Folge­schäden ist –
        soweit gesetzlich zulässig – ausgeschlossen.
      </p>

      <H2>9. Eigentumsvorbehalt</H2>
      <p>
        Die gelieferten Komponenten bleiben bis zur vollständigen Bezahlung des Kaufpreises Eigentum
        der Solanova GmbH.
      </p>

      <H2>10. Datenschutz</H2>
      <p>
        Solanova bearbeitet personen­bezogene Daten ausschliesslich im Rahmen der Datenschutz­erklärung,
        welche integralen Bestandteil dieser AGB bildet.
      </p>

      <H2>11. Anwendbares Recht und Gerichtsstand</H2>
      <p>
        Auf das Vertragsverhältnis findet ausschliesslich schweizerisches Recht Anwendung. Gerichtsstand
        ist der Sitz von Solanova in Wilen-Gottshaus, soweit gesetzlich zulässig.
      </p>

      <H2>12. Schlussbestimmungen</H2>
      <p>
        Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Gültigkeit
        der übrigen Bestimmungen unberührt. Anstelle der unwirksamen Bestimmung gilt diejenige
        Regelung als vereinbart, die dem wirtschaftlichen Zweck am nächsten kommt.
      </p>
    </LegalLayout>
  );
}
